import React from 'react';
import PropTypes from 'prop-types';

function Switch({ children, value }) {
  let PickedCase = null;
  React.Children.forEach(children, (child, i) => {
    if (child.props.value === value) PickedCase = child;
  });

  return PickedCase;
}

Switch.propTypes = {
  children: PropTypes.node,
  value: PropTypes.string,
};

Switch.defaultProps = {
  children: null,
  value: '',
};

export default Switch;
